import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { SharedModule } from 'src/app/shared.module';
import { WidgetsComponentsModule } from 'src/app/components/kit/widgets/widgets-components.module';

import { TopbarComponent } from './Topbar/topbar.component';
import { TopbarLanguageSwitcherComponent } from './Topbar/LanguageSwitcher/language-switcher.component';
import { TopbarSearchComponent } from './Topbar/Search/search.component';
import { TopbarUserMenuComponent } from './Topbar/UserMenu/user-menu.component';
import { TopbarProjectManagementComponent } from './Topbar/ProjectManagement/project-management.component';
import { TopbarFavPagesComponent } from './Topbar/FavPages/fav-pages.component';
import { MenuLeftComponent } from './Menu/MenuLeft/menu-left.component';
import { MenuRightComponent } from './Menu/MenuRight/menu-right.component';
import { FooterComponent } from './Footer/footer.component';
import { TitlesComponent } from './Titles/titles.component';
import { TemplateSidebarComponent } from './Menu/MenuRight/template-sidebar.component';
import { FloatingButtonComponent } from './FloatingButtons/floating-button.component';
import { IconsModule } from '../../kit/icons/icons.module';
import { PrivacyToggleBigButtonComponent } from './FloatingButtons/privacy-toggle-big-button.component';
import { DeveloperSidebarComponent } from './Menu/MenuRight/developer-sidebar.component';

const COMPONENTS = [
	TopbarComponent,
	TopbarSearchComponent,
	TopbarUserMenuComponent,
	TopbarProjectManagementComponent,
	TopbarLanguageSwitcherComponent,
	MenuLeftComponent,
	MenuRightComponent,
	FooterComponent,
	TitlesComponent,
	TemplateSidebarComponent,
	DeveloperSidebarComponent,
	FloatingButtonComponent,
	PrivacyToggleBigButtonComponent,
	TopbarFavPagesComponent
];

@NgModule({
	imports: [
		SharedModule,
		FormsModule,
		ReactiveFormsModule,
		PerfectScrollbarModule,
		WidgetsComponentsModule,
		IconsModule,
	],
	declarations: [...COMPONENTS],
	exports: [...COMPONENTS]
})
export class LayoutModule {}
